export default "__VITE_PUBLIC_ASSET__c429dcde__"